import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './RENT_Distribution_Calculation.css';

const RENT_Distribution_Calculation = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"RENT_DISTRIBUTION_CALCULATION",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	RENT_DISTRIBUTION_CALCULATION:-1
  });


  const [RENT_DISTRIBUTION_CALCULATION, setRENT_DISTRIBUTION_CALCULATION] = React.useState(null);
  const [RENT_DISTRIBUTION_CALCULATION_D, setRENT_DISTRIBUTION_CALCULATION_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Token Distribution Calculation');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/RENT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewRENT_DISTRIBUTION_CALCULATION(clientInfo,"OpenNew");

		navigate('/RENT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutRENT_DISTRIBUTION_CALCULATION(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostRENT_DISTRIBUTION_CALCULATION(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewRENT_DISTRIBUTION_CALCULATION(clientInfo,"OpenNew");
		}
		navigate('/RENT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
		if(Temp_Data2.status!="New"){
			handleDeleteRENT_DISTRIBUTION_CALCULATION(Temp_Data2);
			navigate('/RENT_Distribution_Calculation#New',{replace:true});
		} 
		else 
			navigate('/RENT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Calculation',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!RENT_DISTRIBUTION_CALCULATION) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [RENT_DISTRIBUTION_CALCULATION]) ;


  
  
  var Ids = [];
  for(var Ele in RENT_DISTRIBUTION_CALCULATION){
	  for(var Sec in RENT_DISTRIBUTION_CALCULATION[Ele]){
		if(Sec == "id")
			Ids.push(RENT_DISTRIBUTION_CALCULATION[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(RENT_DISTRIBUTION_CALCULATION[Ele]["status"]);
		else if(Array.isArray(RENT_DISTRIBUTION_CALCULATION[Ele][Sec]))
			  for(var Row in RENT_DISTRIBUTION_CALCULATION[Ele][Sec])  // Convert to RENT_DISTRIBUTION_CALCULATION[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in RENT_DISTRIBUTION_CALCULATION[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["RENT_DISTRIBUTION_CALCULATION"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewRENT_DISTRIBUTION_CALCULATION(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_CALCULATION`).then((response1) => {
		if(!RENT_DISTRIBUTION_CALCULATION) 
			setRENT_DISTRIBUTION_CALCULATION(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_CALCULATION_D`).then((response2) => {
			setRENT_DISTRIBUTION_CALCULATION_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddRENT_DISTRIBUTION_CALCULATION_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewRENT_DISTRIBUTION_CALCULATION = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_CALCULATION/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setRENT_DISTRIBUTION_CALCULATION(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataRENT_DISTRIBUTION_CALCULATION = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_CALCULATION/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutRENT_DISTRIBUTION_CALCULATION = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_CALCULATION/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostRENT_DISTRIBUTION_CALCULATION = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_CALCULATION', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteRENT_DISTRIBUTION_CALCULATION = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_CALCULATION', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2"]=value;
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2",value,Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
  }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3"]=value;
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3",value,Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
  }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_4"]=value;
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_4",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["4"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_0"]=value;
	Form_Data_onChange("4","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["4"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("4","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["5"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("5","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["6"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("6","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["6"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("6","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["6"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("6","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["6"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("6","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["6"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_4"]=value;
	Form_Data_onChange("6","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_4",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["6"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("6","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4"]=value;
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_CALCULATION(Temp_Data);
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
 }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));  
  Temp_Data['2'][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0"] = value;
  setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
};


const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["2"][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1"]=value;
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["2"][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2"]=value;
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["2"][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3"]=value;
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["2"][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4"]=value;
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["2"][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5"]=value;
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  


const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));  
  Temp_Data['3'][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0"] = value;
  setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
};


const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["3"][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1"]=value;
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
	Temp_Data["3"][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2"]=value;
    setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
	//handleAddRENT_DISTRIBUTION_CALCULATION(Temp_Data,App_Data['RENT_DISTRIBUTION_CALCULATION']);
  }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));  
  Temp_Data['3'][index]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3"] = value;
  setRENT_DISTRIBUTION_CALCULATION(Temp_Data);
};




 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!RENT_DISTRIBUTION_CALCULATION) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5']='';
	    break;
	  case('3'):
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2']='';
	    newRow['RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3']='';
	    break;

  }


  const updatedRENT_DISTRIBUTION_CALCULATION =JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
  updatedRENT_DISTRIBUTION_CALCULATION[Sec] = [...updatedRENT_DISTRIBUTION_CALCULATION[Sec], newRow];
  setRENT_DISTRIBUTION_CALCULATION(updatedRENT_DISTRIBUTION_CALCULATION);
};

const handleDeleteRow = (sec,index) => {
  const updatedRENT_DISTRIBUTION_CALCULATION = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_CALCULATION));
  updatedRENT_DISTRIBUTION_CALCULATION[sec].splice(index, 1);
  setRENT_DISTRIBUTION_CALCULATION(updatedRENT_DISTRIBUTION_CALCULATION);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Rental Income Token Distribution Calculation`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Income Token Distribution ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Distribution ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0" type="text" className="form-control" placeholder="RENT Distribution ID" value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Distribution ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1" type="text" className="form-control" placeholder="Offering ID" value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Distribution Period Start`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2" type="date"  value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2`]} 
							onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2_Change} style={{ borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_2"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Distribution Period Start
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Distribution Period End`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3" type="date"  value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3`]} 
							onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3_Change} style={{ borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_3"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Distribution Period End
					  </div>
				  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_4"  value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_4`]} onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_4_Change} className="form-control" name="Distribution Source"  >
						  <option value="Net Rental Income / NOI">Net Rental Income / NOI</option>
						  <option value="Gross Revenue / Net Operating Revenue">Gross Revenue / Net Operating Revenue</option>
						  <option value="Asset Sale Proceeds">Asset Sale Proceeds</option>
						  <option value="NAV Appreciation / Exit Value">NAV Appreciation / Exit Value</option>
						  <option value="Preferred Return / Profit Waterfall">Preferred Return / Profit Waterfall</option>
						  <option value="Pro Rata Income and Exit Proceeds">Pro Rata Income and Exit Proceeds</option>
						  <option value="Interest and Principal Payments">Interest and Principal Payments</option>
						  <option value="Multiple Sources">Multiple Sources</option>
						  <option value="Conditional Auction Pool / Escrow Refund">Conditional Auction Pool / Escrow Refund</option>
						  <option value="Post-Auction Asset Proceeds">Post-Auction Asset Proceeds</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Source
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PM Report ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5" type="text" className="form-control" placeholder="PM Report ID" value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PM Report ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Rent Roll ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6" type="text" className="form-control" placeholder="Rent Roll ID" value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Rent Roll ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reserve Record ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7" type="text" className="form-control" placeholder="Reserve Record ID" value={RENT_DISTRIBUTION_CALCULATION["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_1_7"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reserve Record ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_HEADER">{t(`Distribution Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Distribution Component Type`)}</th>
                        <th>{t(`Gross Source Amount USD`)}</th>
                        <th>{t(`Operating Expenses USD`)}</th>
                        <th>{t(`Reserve Contribution USD`)}</th>
                        <th>{t(`Debt Service USD`)}</th>
                        <th>{t(`Preferred Return USD`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {RENT_DISTRIBUTION_CALCULATION['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0"  onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0_Change(ev, i)}  className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_0`]} name="Distribution Component Type">
						  <option value="Gross Source Amount">Gross Source Amount</option>
						  <option value="Operating Expense">Operating Expense</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Net Distribution">Net Distribution</option>
						  <option value="Investor Distribution">Investor Distribution</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1" type="text" onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_1`]} placeholder="Gross Source Amount USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2" type="text" onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_2`]} placeholder="Operating Expenses USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3" type="text" onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_3`]} placeholder="Reserve Contribution USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4" type="text" onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_4`]} placeholder="Debt Service USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5" type="text" onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_2_5`]} placeholder="Preferred Return USD"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_HEADER">{t(`Distribution Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Distribution Component Type`)}</th>
                        <th>{t(`Net Distributable Income USD`)}</th>
                        <th>{t(`Distribution Per Token USD`)}</th>
                        <th>{t(`Distribution Frequency`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {RENT_DISTRIBUTION_CALCULATION['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0"  onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0_Change(ev, i)}  className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_0`]} name="Distribution Component Type">
						  <option value="Gross Source Amount">Gross Source Amount</option>
						  <option value="Operating Expense">Operating Expense</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Net Distribution">Net Distribution</option>
						  <option value="Investor Distribution">Investor Distribution</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1" type="text" onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_1`]} placeholder="Net Distributable Income USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2" type="text" onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2_Change(ev, i)} className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_2`]} placeholder="Distribution Per Token USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3`]} data-search={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3"  onChange={(ev) => RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3_Change(ev, i)}  className="form-control" value={e[`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_3_3`]} name="Distribution Frequency">
						  <option value="Monthly">Monthly</option>
						  <option value="Quarterly">Quarterly</option>
						  <option value="Semiannual">Semiannual</option>
						  <option value="Annual">Annual</option>
						  <option value="At Exit">At Exit</option>
						  <option value="Event Driven">Event Driven</option>

                                 </select>
                              </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Payment Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_0"  value={RENT_DISTRIBUTION_CALCULATION["4"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_0`]} onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_0_Change} className="form-control" name="Payment Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Received">Received</option>
						  <option value="Cleared">Cleared</option>
						  <option value="Failed">Failed</option>
						  <option value="Refunded">Refunded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Paid">Paid</option>
						  <option value="Partially Paid">Partially Paid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Distribution Approval ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1" type="text" className="form-control" placeholder="Distribution Approval ID" value={RENT_DISTRIBUTION_CALCULATION["4"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Distribution Approval ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Calculation Report Link`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Calculation Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0" type="text" className="form-control" placeholder="Calculation Report Link" value={RENT_DISTRIBUTION_CALCULATION["5"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Calculation Report Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0" type="text" className="form-control" placeholder="Submitted By" value={RENT_DISTRIBUTION_CALCULATION["6"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1" type="text" className="form-control" placeholder="Submitted At" value={RENT_DISTRIBUTION_CALCULATION["6"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2" type="text" className="form-control" placeholder="Reviewed By" value={RENT_DISTRIBUTION_CALCULATION["6"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3" type="text" className="form-control" placeholder="Reviewed At" value={RENT_DISTRIBUTION_CALCULATION["6"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_4"  value={RENT_DISTRIBUTION_CALCULATION["6"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_4`]} onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5" type="text" className="form-control" placeholder="Approval Notes" value={RENT_DISTRIBUTION_CALCULATION["6"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_6_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_0"  value={RENT_DISTRIBUTION_CALCULATION["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_0`]} onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1" type="text" className="form-control" placeholder="Created By" value={RENT_DISTRIBUTION_CALCULATION["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2" type="text" className="form-control" placeholder="Created At" value={RENT_DISTRIBUTION_CALCULATION["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3" type="text" className="form-control" placeholder="Updated By" value={RENT_DISTRIBUTION_CALCULATION["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4" type="text" className="form-control" placeholder="Updated At" value={RENT_DISTRIBUTION_CALCULATION["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_CALCULATION_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default RENT_Distribution_Calculation;  